import PropTypes from 'prop-types';

export const commonEcdSchema = {
  customer: PropTypes.shape({
    customerNumber: PropTypes.string,
    customerId: PropTypes.string,
    transformationBetaStatus: PropTypes.string,
    viewSource: PropTypes.string,
  }),
};
